/* istanbul ignore file */
export enum QueryParams {
    PROGRAM = 'program',
    STAGE = 'stage',
    TIME_RANGE_START = 'timeRangeStart',
    TIME_RANGE_END = 'timeRangeEnd',
    WORKFLOW_ID = 'workflowInstanceId',
    FILTER_QUERY_KEY = 'filterQuery'
}
